import { BottomBar2 } from "../../components/BottomBar";
import { ContactInfoProfiles2 } from "../../components/ContactInfoProfiles";
import { ContactUs } from "../../components/ContactUs";
import { Header2 } from "../../components/Header";
import { Helmet } from "react-helmet";
import { PageTitle } from "../../components/PageTitle";
import React from "react";

const ContactPage = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Contact - Resmi Mirza</title>
      </Helmet>
      <Header2></Header2>
      <PageTitle
        title="Contact Me"
        hometitle="Home"
        homeURL="/"
        currentPage="Contact Me"
      ></PageTitle>
      <section className="pageWrap relative w-full">
        <iframe
          className="w-full relative border-0 -mt-[8.125rem] min-h-[35rem] sm:min-h-[45rem] md:min-h-[60.3125rem]"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29203.450063092678!2d90.428232!3d23.803259!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7750e05bfe7%3A0x8703ac43538cb3cb!2sShaurav%20Das!5e0!3m2!1sen!2sbd!4v1719538702720!5m2!1sen!2sbd"
          allowfullscreen
          loading="lazy"
          title="Contact Map"
        ></iframe>
        {/* Page Wrap */}
      </section>
      <ContactUs></ContactUs>
      <ContactInfoProfiles2></ContactInfoProfiles2>
      <BottomBar2></BottomBar2>
    </React.Fragment>
  );
};

export default ContactPage;
